import React from 'react';

interface EditIconProps {
  className?: string;
}

/** Figma edit pencil (10×10). Color via `className` (e.g. text-background). */
export const EditIcon: React.FC<EditIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M1.25 7.1875V8.75H2.8125L7.42083 4.14167L5.85833 2.57917L1.25 7.1875ZM8.62917 2.93333C8.79167 2.77083 8.79167 2.50833 8.62917 2.34583L7.65417 1.37083C7.49167 1.20833 7.22917 1.20833 7.06667 1.37083L6.30417 2.13333L7.86667 3.69583L8.62917 2.93333V2.93333Z"
      fill="currentColor"
    />
  </svg>
);
